export type Listener<T> = (payload: T) => void;

/** Minimal typed event emitter. `on` returns an unsubscribe function. */
export class Emitter<T> {
  private readonly listeners = new Set<Listener<T>>();

  on(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(payload: T): void {
    for (const listener of [...this.listeners]) {
      try {
        listener(payload);
      } catch (error) {
        console.error('Petal Plains: listener failed', error);
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
